<script>
    export default {
        props: ['data'],
        data () {
            return {
            }
        }
    };
</script>
<template>
    <div class="dark-bg--style7">
        <div class="container">
            <div class="row text-center text-lg-left p-md-4">
                <div class="col-sm-4"  v-for="item in data" :key="item.id">
                    <div class="row">
                        <div class="col-sm-2 mt-3">
                            <img :src="item.image" alt="icon" class="home-icon">
                        </div>
                        <div class="col-sm-10 mt-3 pl-4">
                            <h3 class="text-white">
                                {{item.title}}
                            </h3>
                            <p class="text-white font-size-15">
                                {{item.body}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>